if (!window.parmonic_disable_init) window.setupParmonicWidget()
